import styled from 'styled-components';
import { Col } from 'antd'

export const SliderComp = styled.div` 
	width:99%;
	display:inline-block;
	.ant-slider{
		margin-top: 10px;
	}
	.ant-slider-handle{
		border-radius: 0;
		border:transparent;
		width:10px;
		height:18px;
		margin-top: -9px;
		margin-left: -5px;
		background-color: ${props => props.theme.fontColors.primary};
	}
	.ant-slider-track{
		background-color: ${props => props.theme.backgroundColor.layoutLight};
	}
	.ant-slider:hover .ant-slider-track{
		background-color:${props => props.theme.backgroundColor.layoutLight};
	}
	.ant-tooltip-arrow::before {
		width: 5px;
		height: 5px;
		content: '';
		display: block;
		margin: auto;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: ${props => props.theme.fontColors.primary} !important;
		position: absolute;
		pointer-events: auto;
	}
`;

export const SliderTitle = styled.p`
	text-align:left;
`;

export const FilterCol = styled(Col)`
	padding-bottom:1.5625rem;
	max-height:6.25rem
`;

export const TabTitles = styled.p`
	font-family: ${props => props.theme.fontFamily.helveticaNeue};
	font-size: ${props => props.theme.fontSize.primary};
	font-style: : ${props => props.theme.fontWeight.normal};
	font-stretch: : ${props => props.theme.fontStretch.normal};
	line-height: ${props => props.theme.lineHeight.primary};
	letter-spacing: ${props => props.theme.letterSpacing.zero};
	color:${props => props.theme.fontColors.headingColor};
	margin-bottom:0.3125rem;
	@media (max-width: 991px) {
    	font-size:${props => props.theme.fontSize.secondary};
		line-height: ${props => props.theme.lineHeight.secondary};
    	margin-top:0.3125rem;
  }
`;

export const Reset = styled.p`
	font-family: ${props => props.theme.fontFamily.helveticaNeue}; 
	font-size: ${props => props.theme.fontSize.primary};
	color:${props => props.theme.fontColors.primary};
	line-height: ${props => props.theme.lineHeight.primary};
	text-decoration: underline;	
	@media (max-width: 991px) {
    font-size:${props => props.theme.fontSize.secondary};
		line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const TextWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	padding-top:1.5rem;
`;

export const MinMaxWrap = styled.div`
	display:flex;
	justify-content:space-between;
`;

export const Min = styled.div`
	font-family: ${props => props.theme.fontFamily.helveticaNeue};
	font-size: ${props => props.theme.fontSize.primary};
	color:${props => props.theme.fontColors.headingColor};
	line-height: ${props => props.theme.lineHeight.primary};
	height:30px;
	display:flex;
	@media (max-width: 991px) {
    	font-size:${props => props.theme.fontSize.secondary};
		line-height: ${props => props.theme.lineHeight.secondary};
    }
`;

export const Max = styled.div`
	font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    color:${props => props.theme.fontColors.headingColor};
	line-height: ${props => props.theme.lineHeight.primary};
	height:30px;
	display:flex;
	@media (max-width: 991px) {
    	font-size:${props => props.theme.fontSize.secondary};
		line-height: ${props => props.theme.lineHeight.secondary};
    }
`;